import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import car1 from "./assets/car1.png";
import mini from "./assets/mini.png";
import luxury from "./assets/luxury.png";
import sedan from "./assets/sedan.png";
import bike from "./assets/bike.png";
import suv from "./assets/suv.png";
import auto from "./assets/auto.png";
import Evcar from "./assets/Evcar.png";
import rolopink from "./assets/rolopink.png";
import bookridebg from "./assets/bookridebg.png";
import twitter from "./assets/logo/twitter.png";
import linkedIn from "./assets/logo/LinkedIn.png";
import insta from "./assets/logo/insta.png";
import fb from "./assets/logo/fb.png";

import bookride from "./assets/bookride.jpg";
import { useState } from "react";
import { sendContactMessage } from "./services/authService";
import { toast } from "react-toastify";
function BookRide() {
  const [userType, setUserType] = useState("");
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile_no: "",
    you_are: "",
    organization_name: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

const handleChange = (e) => {
  const { name, value } = e.target;

  // ✅ NAME → allow only letters & space
  if (name === "name") {
    const onlyText = value.replace(/[^A-Za-z ]/g, "");
    setFormData({ ...formData, name: onlyText });
    return;
  }

  // ✅ CONTACT → only numbers + max 10 digits
  if (name === "mobile_no") {
    const onlyNumbers = value.replace(/[^0-9]/g, "").slice(0, 10);
    setFormData({ ...formData, mobile_no: onlyNumbers });
    return;
  }

  // default
  setFormData({
    ...formData,
    [name]: value,
  });
};

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      const res = await sendContactMessage(formData);

      if (res.success === "1") {
        toast.success(res.message); // ✅ SUCCESS TOAST

        setFormData({
          name: "",
          email: "",
          mobile_no: "",
          you_are: "",
          organization_name: "",
          message: "",
        });
      } else {
        toast.error(res.message); // fallback
      }
    } catch (error) {
      console.error(error);

      toast.error(error?.message || "Failed to send message. Try again."); // ❌ ERROR TOAST
    } finally {
      setLoading(false);
    }
  };
  return (

    
    <div  className="App background" style={{ overflowX: "hidden" }}>
      <Navbar />

      {/* HERO */}
      <section
        className="hero"
        style={{ backgroundImage: `url(${bookridebg})` }}
      >
        <div className="hero-content">
          <h1>
           Our Transit Services: City Rides,Intercity & More
          </h1>

          <p>Our all-in-one transit partner for rides,<br/> deliveries and more.</p>

          <p>
            Rolo Transit offers a ride for every <br/>requirement, from quick city
            pickups to <br/>long-distance trips.
          </p>
        </div>

        <img className="hero-car" src={car1} alt="car" />

        {/* CURVE DIVIDER */}
        <div className="hero-curve">
          <svg viewBox="0 0 1440 150" preserveAspectRatio="none">
            <path
              d="M0,80 C300,160 1100,0 1440,100 L1440,150 L0,150 Z"
              fill="#f5e6d9"
            ></path>
          </svg>
        </div>
      </section>
      
 {/* VEHICLES */}
      <section class="vehicle-section">
        <h2>Choose the right vehicle</h2>

        <div class="vehicle-list">
          <div class="vehicle-item left">
            <div class="vehicle-text">
              <h4>Micro/Mini</h4>
              <p>Compact, comfortable cars for city commutes.</p>
            </div>
            <img src={mini} />
          </div>

          <div class="vehicle-item right">
            <div class="vehicle-text">
              <h4>Sedan</h4>
              <p>Spacious rides with extra legroom.</p>
            </div>
            <img src={sedan} />
          </div>

          <div class="vehicle-item left">
            <div class="vehicle-text">
              <h4>Luxury / Premium</h4>
              <p>Premium experience with top-class comfort.</p>
            </div>
            <img src={luxury} />
          </div>

          <div class="vehicle-item right">
            <div class="vehicle-text">
              <h4>Bike</h4>
              <p>Fast, affordable rides for short distances.</p>
            </div>
            <img src={bike} />
          </div>

          <div class="vehicle-item left">
            <div class="vehicle-text">
              <h4>SUV</h4>
              <p>More space, comfort, and luggage capacity.</p>
            </div>
            <img src={suv} />
          </div>

          <div class="vehicle-item right">
            <div class="vehicle-text">
              <h4>Auto</h4>
              <p>Convenient and budget-friendly rides.</p>
            </div>
            <img src={auto} />
          </div>

          <div class="vehicle-item left">
            <div class="vehicle-text">
              <h4>EV/Rolo Green</h4>
              <p>Zero-emission electric rides for a cleaner planet.</p>
            </div>
            <img src={Evcar} />
          </div>

          <div class="vehicle-item right">
            <div class="vehicle-text">
              <h4>Rolo Pink</h4>
              <p>Safe, comfortable rides driven by women, for women.</p>
            </div>
            <img src={rolopink} />
          </div>
        </div>
      </section>

      {/* LOGISTICS */}
      <section className="section dark">
        <div className="section-inner">
          <h2>Logistics & Utility Services</h2>

          <div className="card-grid">
            <div className="service-card">
              <h4>Porter:</h4>
              <p>Goods transportation service for intra-city and inter-city.</p>
            </div>

            <div className="service-card">
              <h4>Pet Pickup & Drop:</h4>
              <p>Safe and comfortable travel for your furry companions.</p>
            </div>

            <div className="service-card">
              <h4>Delivery:</h4>
              <p>Safe & fast parcel delivery both inside and between cities.</p>
            </div>

            <div className="service-card">
              <h4>Metro Fleet:</h4>
              <p>
                Personalized transport solutions for metro stations, staff, and
                passengers.{" "}
              </p>
            </div>

            <div className="service-card">
              <h4>Packing & Moving:</h4>
              <p>End-to-end relocation support for homes as well as offices.</p>
            </div>

            <div className="service-card">
              <h4>Emergency:</h4>
              <p>Quick rides for urgent travel or emergencies.</p>
            </div>
          </div>
        </div>
      </section>

      {/* RIDES */}
      <section className="section light">
        <div className="section-inner">
          <h2>Rides & Travel</h2>

          <div className="card-grid">
            <div className="ride-card">
              <h4>Pick & Drop (Within City):</h4>
              <p>Fast, reasonable rides for your everyday city travel.</p>
            </div>

            <div className="ride-card">
              <h4>Outstation (Carpooling):</h4>
              <p>Affordable and eco-friendly long-distance shared rides.</p>
            </div>

            <div className="ride-card">
              <h4>Rolo Pink:</h4>
              <p>
                Exclusive rides by and for women safe, comfortable, and secure.
              </p>
            </div>

            <div className="ride-card">
              <h4>Rolo Green:</h4>
              <p>
                Eco-friendly rides using electric and hybrid vehicles for a
                cleaner tomorrow.
              </p>
            </div>

            <div className="ride-card">
              <h4>Self Drive:</h4>
              <p>
                You can rent a car and drive on your own with flexible packages.
              </p>
            </div>

            <div className="ride-card">
              <h4>Rentals:</h4>
              <p>
                {" "}
                Hourly and full-day rental options for both personal and
                commercial use.
              </p>
            </div>
          </div>
        </div>
      </section>

      
     
      {/* WHY */}
      {/* WHY */}
      <section className="section dark why">
        <div className="section-inner why-container">
          <div className="why-text">
            <h2>What Makes Us Different</h2>

            <p>
               Rolo Transit is not just another cab service organization but
              it's a smart and safe mode of transportation . we integrate
              technology, transparency and trust to make your every ride better
              for riders and drivers. To make your every journey better for
              riders, drivers, we integrate technology, transparency and trust.
            </p>
            <p>Affordable priced and open Fair pricing, no hidden charges.</p>

            <div className="why-points">
              <p>
                <span>Safe & Verified :</span> <br />
                Trained, verified drivers and round-the-clock safety support.
              </p>

              <p>
                <span>Eco-Conscious Travel :</span>
                <br />
                Promoting EVs and carpooling to save the environment.
              </p>

              <p>
                <span>Inclusive Services :</span> <br />
                Rolo Pink is an inclusive service run by and for women.
              </p>

              <p>
                <span>Reliable Network :</span>
                <br />
                from quick pickups to a pristine cabin and a professional at the
                wheel.
              </p>

              <p>
                <span>Community Driven :</span> <br />
                Empowering drivers with fair pay and growth opportunities.
              </p>
            </div>
          </div>

          {/* IMAGE */}
          <div className="why-image">
            <img src={bookride} alt="rolo vehicle" />
          </div>
        </div>
      </section>

      {/* CONTACT */}
      <section
        class="  rounded-0"
        style={{ maxWidth: "100%", color: "#FFFFFF" }}
      >
        <div class="row justify-content-center mb-5">
          <div class="col-12 col-md-6 px-4 mb-4 mb-md-0">
            <div class="p-4">
              <h2
                className="text-bold"
                style={{
                  fontSize: "40px",
                  background:
                    "linear-gradient(90deg,rgba(255, 127, 31, 1) 0%, rgba(210, 90, 0, 1) 80%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  lineHeight: "50px",
                }}
              >
                {" "}
                Get in Touch with Rolo Transit
              </h2>
              <p>
                Please contact us for any questions, feedback, or potential
                collaboration. Let’s simplify easy and trushworthy city
                travelling. We are always here to support you, whether you are a
                rider, a driver, or a partner.
              </p>
              <div class="container mt-4">
                <div class="row align-items-start mb-3">
                  <div class="col-auto"></div>
                  <div class="col-auto">
                    <span className="fw-light">
                      4th Floor, Netcheck house/ Pasalkar Chembers, <br /> Sr.
                      no. 6/10, 401 to 404, behind Indian oil, <br /> Ambegaon
                      Budruk, Pune, Maharashtra 411041
                    </span>
                  </div>
                </div>

                <div class="row align-items-start mb-3">
                  <div class="col-auto"></div>
                  <div class="col">
                    <strong>General Support</strong>
                    <br />{" "}
                   <a
  href="mailto:support@rolotransit.com"
  className="fw-light"
  style={{ fontSize: "16px", color: "inherit", textDecoration: "none" }}
>
  support@rolotransit.com
</a>
                  </div>
                </div>

                <div class="row align-items-start mb-3">
                  <div class="col-auto"></div>
                  <div class="col">
                    <strong>Lets Talk:</strong>
                    <br /> <span className="fw-light">+91-7507500300</span>
                  </div>
                </div>

                <div className="d-flex gap-3 social-icons">
                  <a
                    href="https://www.linkedin.com/company/rolo-transit-platforms-pvt-ltd/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={linkedIn} alt="LinkedIn" />
                  </a>

                  <a
                    href="https://x.com/rolotransit?s=21"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={twitter} alt="Twitter" />
                  </a>

                  <a
                    href="https://www.instagram.com/rolotransit/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={insta} alt="Instagram" />
                  </a>

                  <a
                    href="https://www.facebook.com/rolotransit"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={fb} alt="Facebook" />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 px-4">
            <div className="p-4">
              <p>
                Fill the form and our team will get back to you at the earliest.
              </p>
 <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label
                    htmlFor="name"
                    className="form-label"
                    style={{ fontWeight: "bold", fontSize: "14px" }}
                  >
                    *Name
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="form-control custom-input"
                    placeholder="Your name"
                  
                    required
                    style={{
                      backgroundColor: "#ffffff31",
                      color: "#ffffff",
                      borderColor: "#ffffff42",
                   
                    }}
                  />
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <label
                      className="form-label fw-bold"
                      style={{ fontWeight: "bold", fontSize: "14px" }}
                    >
                      *Email
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="form-control custom-input"
                      placeholder="you@example.com"
                      required
                      style={{
                        backgroundColor: "#ffffff31",
                        color: "#ffffff",
                        borderColor: "#ffffff42",
                      }}
                    />
                  </div>

                  <div className="col-md-6">
                    <label
                      className="form-label fw-bold"
                      style={{ fontWeight: "bold", fontSize: "14px" }}
                    >
                      Contact Number
                    </label>
                    <input
                      type="text"
                      name="mobile_no"
                      value={formData.mobile_no}
                      onChange={handleChange}
                      className="form-control custom-input"
                      placeholder="+91-0000000000"
                      style={{
                        backgroundColor: "#ffffff31",
                        color: "#ffffff",
                        borderColor: "#ffffff42",
                      }}
                    />
                  </div>
                </div>

             <div className="mb-3">
  <label
    className="form-label fw-bold"
    style={{ fontWeight: "bold", fontSize: "14px" }}
  >
    *You are a
  </label>

 <select
  name="you_are"
  value={formData.you_are}
  onChange={handleChange}
  className="form-control"
  style={{
    backgroundColor: "#ffffff31",
    color: formData.you_are ? "#ffffff" : "#000000",
    borderColor: "#ffffff42",
  }}
>
  <option value="" style={{ color: "#000" }}>
    -Select-
  </option>

  <option value="Driver" style={{ color: "#000" }}>
    Driver
  </option>

  <option value="Individual" style={{ color: "#000" }}>
    Customer
  </option>

  <option value="Organization" style={{ color: "#000" }}>
    Organization
  </option>
</select>
</div>
                {formData.you_are === "Organization" && (
                  <div className="mb-3">
                    <label
                      className="form-label fw-bold"
                      style={{ fontWeight: "bold", fontSize: "14px" }}
                    >
                      *Organization Name
                    </label>
                    <input
                      type="text"
                      name="organization_name"
                      value={formData.organization_name}
                      onChange={handleChange}
                      className="form-control custom-input"
                      placeholder="Enter organization name"
                      required
                      style={{
                        backgroundColor: "#ffffff31",
                        color: "#ffffff",
                        borderColor: "#ffffff42",
                      }}
                    />
                  </div>
                )}

                <div className="mb-3">
                  <label
                    htmlFor="message"
                    className="form-label"
                    style={{ fontWeight: "bold", fontSize: "14px" }}
                  >
                    *Message
                  </label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    className="form-control custom-input"
                    rows="4"
                    placeholder="Your message..."
                    required
                    style={{
                      backgroundColor: "#ffffff31",
                      color: "#ffffff",
                      borderColor: "#ffffff42",
                    }}
                  />
                    <span
                    style={{
                      fontSize: "12px",
                      color: "#FFFFFF",
                      marginTop: "5px",
                      display: "block",
                    }}
                  >
                    By using this website, you consent to our use of cookies and
                    collection of personal data as outlined in our Privacy
                    Policy.
                  </span>
                </div>

                <div className="mb-3">
                  <button
                    type="submit"
                    className="btn btn-dark rounded-pill py-2"
                  >
                    {loading ? "Sending..." : "Send Message"}
                  </button>
                </div>
              </form>
            
            </div>
          </div>
        </div>
      </section>

      <Footer />

      {/* CSS IN SAME FILE */}
      <style>{`

      .custom-input {
  color: #ffffff !important;
}

.custom-input::placeholder {
  color: #000000 !important;
  opacity: 1;
}

      .bookride{
       
        color:white;
        font-family:Arial;
      }

.hero{
  height:85vh;
  background-size:cover;
  background-position:center;
  display:flex;
  align-items:center;
  justify-content:space-between;
  padding:90px;
  position:relative;
  overflow:hidden;
}

.hero::after{
  content:"";
  position:absolute;
  bottom:-1px;
  left:0;
  width:100%;
  height:220px;
  background:#FBEFE6;

  clip-path: polygon(0 45%, 100% 0%, 100% 100%, 0% 100%);
  z-index:1;
}

.hero::before{
  content:"";
  position:absolute;
  inset:0;
  background:rgba(0,0,0,0.75); /* darker overlay */
  z-index:1;
}

.hero-content{
  position:relative;
  max-width:650px;
  z-index:2;
  margin-left:60px;
}

.hero h1{
  font-size:60px;
  color:#ff8c32;
  font-weight:700;
}

.hero-car{
  position:absolute;
  right:10px;        /* move slightly left */
  bottom:-60px;       /* pushes car into white section */
  width:1000px;        /* bigger car */
  z-index:3;          /* above the cut shape */
  
}

/* CURVE */
.hero-curve{
  position:absolute;
  bottom:-1px;
  left:0;
  width:100%;
  height:150px;
}

.hero-curve svg{
  width:100%;
  height:100%;
}

      .hero p{
        margin-top:15px;
        line-height:1.6;
      }

.section.light{
  // background:#FBEFE6;
  color:#000;
  margin-top:-120px;
  padding-top:120px;
  position:relative;
  z-index:2;
}
   .section{
  padding:50px 0;
}

.section-inner{
  max-width:1200px;
  margin:auto;

}

.section h2{
  font-size:28px;
  font-weight:700;
  margin-bottom:25px;

  background: linear-gradient(90deg, #FF7F1F 0%, #C25300 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

      .light{
        // background:#f5e6d9;
        // color:#000;
      }

      // .dark{
      //   background:#000;
      // }

.card-grid{
  display:grid;
  grid-template-columns:repeat(2, 1fr);
  gap:24px;
  margin-top:30px;
}
.ride-card{
  background:#F3CDB1;
  padding:22px;
  border-radius:12px;
  border:2px solid #C25300;
  transition:0.3s;
  min-height:90px;
  display:flex;
  flex-direction:column;
  justify-content:center;
}

.ride-card h4{
  color:#C25300;
  margin-bottom:8px;
  font-weight:700;
}

.ride-card p{
  color:#000000;
  font-size:14px;
}

.ride-card:hover{
  transform:translateY(-3px);
  box-shadow:0 6px 20px rgba(0,0,0,0.15);
}

.service-card{
  background:#fff;
  padding:22px;
  border-radius:12px;
  border:2px solid #f1e3d7;
  transition:0.3s;
  min-height:90px;
  display:flex;
  flex-direction:column;
  justify-content:center;
}

.service-card h4{
  color:#C25300;
  margin-bottom:8px;
  font-weight:600;

}

.service-card p{
  color:#444;
  font-size:14px;
}

.service-card:hover{
  transform:translateY(-3px);
  box-shadow:0 6px 20px rgba(0,0,0,0.15);
}

   .vehicle-section{
  padding:50px 10%;
  // background:#000;
}


.vehicle-section h2{
  color:#ff8c32;
  margin-bottom:40px;
}

/* LIST */
.vehicle-list{
  display:flex;
  flex-direction:column;
  gap:5px;
}

/* CARD */
.vehicle-item{
  position:relative;
  display:flex;
  align-items:center;
  background:#eee;
  color:#000;
  padding:25px 40px;
  border-radius:14px;
  width:500px;
  transition: all 0.3s ease;
}

/* HOVER EFFECT */
.vehicle-item:hover{
  transform: translateY(-6px);
  box-shadow: 0 10px 25px rgba(0,0,0,0.35);
  background:#ffffff;
}

   

/* TEXT */
.vehicle-text h4{
  color:#C25300;
  margin-bottom:6px;
}

.vehicle-text p{
  font-size:14px;
}

/* IMAGE */
.vehicle-item img{
  position:absolute;
  width:180px;
  transition: transform 0.3s ease;
}

.vehicle-item:hover img{
  transform: scale(1.08);
}

/* LEFT CARD */
.vehicle-item.left{
  margin-right:20px;
}

.vehicle-item.left img{
  right:-30px;
}

/* RIGHT CARD */
.vehicle-item.right{
  margin-left:auto;
flex-direction:row;
 padding-left:150px;
}

.vehicle-item.right img{
  left:-30px;
}
  .why-container{
  display:flex;
  gap:70px;
  align-items:center;
}

.why-text{
  flex:1;
  max-width:520px;
}

.why-text p{
  color:#ccc;
  line-height:1.6;
  margin-bottom:18px;
}

.why-points p{
  margin-bottom:10px;
  font-size:14px;
}

.why-points span{
  color:#ff8c32;
  font-weight:600;
}

/* IMAGE BOX */

.why-image{
  flex:1;

  
}

.why-image img{
  width:80%;
  border-radius:10px;
  
  object-fit:contain;
}
      .contact{
        background:#111;
      }

      .contact-grid{
        display:grid;
        grid-template-columns:1fr 1fr;
        gap:40px;
      }

      .contact-form{
        display:flex;
        flex-direction:column;
        gap:10px;
      }

      .contact-form input,
      .contact-form textarea{
        padding:10px;
        border-radius:5px;
        border:none;
      }

      .contact-form button{
        background:#ff8c32;
        border:none;
        padding:12px;
        color:white;
        cursor:pointer;
        border-radius:5px;
      }
.social-icons img{
  width:40px;
  height:40px;
  object-fit:contain;
  transition:0.3s;
}

.social-icons img:hover{
  transform:scale(1.15);
}
      `}</style>
    </div>
  );
}

export default BookRide;
